<template>
  <div>
    <v-container fluid>
      <v-row justify="space-around">
        <v-col cols="12" lg="8" class="my-2 pa-0">
          <p class="ffP fs14 fcT240 mb-3">{{$t('channelInfo.responsibleHint')}}</p>
          <v-data-table :headers="dTableHeaders"
                        :items="dManagers"
                        :item-key="dItemKey"
                        :loading="dLoading"
                        :no-data-text="$t('channelInfo.noManagers')"
                        :loading-text="$t('datGeneric.loading')"
                        :header-props="dHeaderProps"
                        :items-per-page="10"
                        :footer-props="{'items-per-page-options':[5,10,20], 'items-per-page-text': $t('labels.elementsPerPage'), 'pageText': '{0}-{1} de {2}' }"
                        class="datTable">
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'
import ServiceEcomplaints from '@/services/srv-eComplaints'
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'

export default {
  name: 'EComplaintManagers',

  mixins: [mxCanalDenuncias],

  props: {
    pComplaintInfo: {
      type: Object,
      required: false
    },
    pShowSnackbar: {
      type: String,
      default: 'BOTH'
    }
  },

  mounted() {
    this.fGetManagersDen()
  },

  data() {
    return {
      dExternalOrigin: localStorage.getItem('externOrigin'),
      dItemKey: 'usuario',
      dManagers: [],
      dLoading: false,
      dTableHeaders: [
        {
          text: this.$t('datTableHeader.user'),
          value: 'usuario',
          align: 'left',
          sortable: true,
          class: ''
        },
        {
          text: this.$t('channelInfo.fullName'),
          value: 'nombreCompleto',
          align: 'left',
          sortable: true,
          class: ''
        },
        {
          text: this.$t('compDetails.email'),
          value: 'email',
          align: 'left',
          sortable: true,
          class: ''
        }
      ],
      dHeaderProps: { sortByText: this.$t('datGeneric.sortBy') }
    }
  },

  methods: {
    fGetManagersDen() {
      this.dLoading = true
      const payload = {}
      const service = this.dExternalOrigin
        ? ServiceEcomplaintsPublic
        : ServiceEcomplaints

      service.getManagersDen(payload).then(response => {
        if (response.statusCode === '200' && response.result !== 'ko') {
          this.dManagers = response.dataRes || []
        }
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      }).finally(() => {
        this.dLoading = false
      })
    }
  }
}
</script>
